import { QueryHandlingService } from '@aando/core';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { catchError, defer, map, of, retry, timer } from 'rxjs';
import {
  CurrentUserGQL,
  CurrentUserQuery,
  CurrentUserQueryVariables,
  User,
} from 'src/graphql/graphql-auth';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private readonly currentUserGQL = inject(CurrentUserGQL);
  private readonly qhs = inject(QueryHandlingService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  readonly currentUser = signal<User | null>(null);

  private readonly currentUser$ = defer(
    () => this.qhs.fetch<CurrentUserQuery, CurrentUserQueryVariables>(this.currentUserGQL).data,
  ).pipe(
    map((d) => d?.currentUser ?? null),
    retry({ count: 2, delay: (_, i) => timer(300 * (i + 1)) }),
    catchError(() => of(null)),
  );

  fetchUser(withNavigate: string | null = null): void {
    this.currentUser$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.currentUser.set(data as User);
      if (withNavigate) {
        this.router.navigate(['/lots']);
      }
    });
  }
}
